// extracted by mini-css-extract-plugin
export default {"pulse":"AppPin_pulse__eoAjn"};